import "./js/inputMask"
import "./js/searchInput"
import "./js/slider"
import "./js/modal"
import "./js/formSubmit"
import "./js/accordion"
import "./js/select"
import "./js/tabs"
import { initTooltips } from "./js/tooltip"

initTooltips()
